import styled from 'styled-components';

export const PlaceholderChip = styled.span.attrs<{ $active?: boolean }>((props) => ({
  className: `inline-flex items-center rounded px-0.5 text-sm ${
    props.$active ? 'ring-2 ring-offset-0 ring-vantis-violet' : ''
  }`,
}))<{ $active?: boolean }>`
  color: var(--placeholder-fg);
`;

export const TextMarkEditFrame = styled.span.attrs<{ $active?: boolean }>((props) => ({
  className: `inline-flex items-center rounded px-0.5 text-sm ${
    props.$active ? 'ring-2 ring-vantis-violet' : ''
  }`,
}))<{ $active?: boolean }>`
  color: var(--placeholder-fg);
`;

export const TextMarkInput = styled.input.attrs({
  className: 'text-sm outline-none',
})`
  color: var(--placeholder-fg);
  field-sizing: content;
  min-width: 0.5ch;
  margin: 0;
  padding: 0;
  border: 0;
  background: transparent;
`;

// Holds the same width the empty input occupies, so an idle [ ] and an active [|] line up and the
// surrounding text never shifts when the slot is selected.
export const TextMarkGap = styled.span`
  display: inline-block;
  width: 0.5ch;
`;
